import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
    LIST,
    FAILURE,
    SUCCESS,
    REQUEST
} from '../../../../redux/ActionType';
import { MY_JOB_APPLICATIONS } from '../../constants';
import * as services from '../../../services/JobApplications';

function* list({ payload }) {
    try {
        const params = payload.params
            ? payload.params
            : yield select(state => state.dataTables.dataTableState.myApplications.params);
        const collaboratorId = yield select(state => state.Auth.collaborator.id);
        const response = yield call(services.getMyJobApplications, collaboratorId, params);
        yield put({
            type: SUCCESS(LIST(MY_JOB_APPLICATIONS)),
            payload: { ...response }
        });
    } catch (error) {
        yield put({ type: FAILURE(LIST(MY_JOB_APPLICATIONS)), payload: error });
    }
}

export function* watchMyJobApplications() {
    yield takeLatest(REQUEST(LIST(MY_JOB_APPLICATIONS)), list);
}
